module.exports = __webpack_public_path__ + "static/bagel@2x-af4ac914fc18d86f2f760d354275af00.png";